import React from 'react';
import RiskCheckboxCommon from './RiskCheckboxCommon';
import { FlammableCategory } from '@components/Activity/types/FlammableCategory';
import { MitigationMeasures } from '@components/Activity/types/MitigationMeasures';
import { OrganisationalMeasures } from '@components/Activity/types/OrganisationalMeasures';
import { PreventionMeasures } from '@components/Activity/types/PreventionMeasures';
import { AffectedGroupState } from '@components/Activity/types/AffectedGroupState';
import { WorkerTrainingInformation } from '@components/Activity/types/WorkerTrainingInformation';

type ItemKeys =
  | keyof MitigationMeasures
  | keyof PreventionMeasures
  | keyof AffectedGroupState
  | keyof FlammableCategory
  | keyof OrganisationalMeasures
  | keyof WorkerTrainingInformation;

type CommonProps<
  T extends
    | MitigationMeasures
    | PreventionMeasures
    | AffectedGroupState
    | FlammableCategory
    | OrganisationalMeasures
    | WorkerTrainingInformation
> = {
  items: ItemKeys[];
  state: T;
  setState?: (newState: T) => void;
  text?: string;
  setText?: (text: string) => void;
  titleKey: string;
  otherKey?: keyof T;
  checkboxKeyPrefix: string;
  edms?: string;
  setEdms?: (edms: string) => void;
  placeholder?: string;
  placeholderOther?: string;
  disabled?: boolean;
};

const RiskCheckboxSection = <
  T extends
    | MitigationMeasures
    | PreventionMeasures
    | AffectedGroupState
    | FlammableCategory
    | OrganisationalMeasures
    | WorkerTrainingInformation
>({
  titleKey,
  items,
  state,
  setState,
  text,
  setText,
  otherKey,
  checkboxKeyPrefix,
  edms,
  setEdms,
  placeholder,
  placeholderOther,
  disabled,
}: CommonProps<T>) => (
  <RiskCheckboxCommon
    items={items}
    state={state}
    setState={setState}
    text={text}
    setText={setText}
    titleKey={titleKey}
    checkboxKeyPrefix={checkboxKeyPrefix}
    otherKey={otherKey}
    placeholderOther={placeholderOther}
    placeholder={placeholder}
    edms={edms}
    setEdms={setEdms}
    disabled={disabled}
  />
);

export default RiskCheckboxSection;
